module.exports = __webpack_public_path__ + "img/Best of Genf weiss.d589cba8.jpg";